<template>
	<div class="home">
		<HeaderBar :title="title"></HeaderBar>
		<div class="center-box-no-footer">
			<van-search v-model="searchValue" show-action placeholder="姓名搜索..." @search="onSearch" clearable>
				<template #action>
					<div @click="onSearch" class="filter-box">
						筛选
						<van-icon name="filter-o" />
					</div>
				</template>
			</van-search>
			<van-list offset="10" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
				class="list-box">
				<van-cell v-for="item in list" :key="item.id" center is-link @click="Detail(item)">
					<template #title>
						<span class="patient-title custom-title" >{{item.bq001001}}</span>
						<span class="patient-title custom-title" style="font-size: 15px;margin-left: 1rem;">{{item.bq001002}}</span>
						<span class="patient-title custom-title" style="font-size: 15px;margin-left: 0.2rem;">{{item.bq001003==1?'男':'女'}}</span>
						<span class="patient-title custom-title" style="font-size: 15px;margin-left: 0.2rem;">{{item.age}}岁</span>
						<!-- <span class="patient-title custom-title">{{item.EmployerName}}</span> -->
					</template>
					<template #label>
						<div class="patient-detail" >
							<div class="patient-detail-item">{{(item.bq001040+'').substring(0,10)}}</div>
							<div class="patient-status active" style="width: 8rem;margin-left: 1rem;" v-if="item.Bq001_042==1">
								<span>下次随访：{{item.extend2}}</span>
							</div>
						</div>
						<div class="patient-detail" style="margin-top: 0.3rem;">
							<div class="patient-detail-item">
								<!-- <van-tag type="success" v-if="item.Bq001_042==1 && item.extend5==''" plain>入组成功</van-tag>
								<van-tag type="danger" v-if="item.Bq001_042==2" plain>未成功入组</van-tag>
								<van-tag type="warning" v-if="item.Bq001_042==1 && item.extend5!=''" plain>数据缺失</van-tag> -->
								<van-tag type="success" v-if="item.Bq400_996==3" plain>入组成功</van-tag>
								<van-tag type="danger" v-if="item.Bq400_996==1" plain>数据转化中</van-tag>
								<van-tag type="danger" v-if="item.Bq400_996==2" plain>数据异常</van-tag>
								<van-tag type="warning" v-if="item.Bq400_996==0" plain>数据采集</van-tag>
							</div>
							<div class="patient-detail-item" style="font-size: 12px;">{{item.EmployerName}}</div>
						</div>
					</template>
					
				</van-cell>
			</van-list>
		</div>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
	export default {
		name: 's400PatientList',
		data() {
			return {
				condition: {
					bq001018: "",
					bq001002: "",
					bq001042: '1',
					currentPage: 1,
					pageIndex: 1,
					pageSize: 10,
					recordCount: 0,
					menuid:"dbff3de6-2d07-4627-b33c-7c0ca9bc57b9"
				},
				title: '随访列表',
				searchUrl: this.$utils.Url.s400 + '/api/S400Bq400/List',
				loading: false,
				finished: false,
				searchValue: "",
				list: [],
			}

		},
		components: {

		},
		methods: {
			onLoad() {
				let that = this
				that.loading = true
				that.$utils.HttpPost(that.searchUrl, that.condition, function(data) {
					that.condition.pageIndex++
					that.condition.currentPage++
					let dataList = data.data
					dataList.forEach(function(item) {
						that.$utils.CopyKeyInfo(item,item)
						that.list.push(item)
					})
					if (that.list.length >= data.pager.RecordCount) {
						that.finished = true
					}
					that.loading = false
				})
			},
			onSearch() {
				let that = this
				that.condition.currentPage = 1
				that.condition.bq001002 = this.searchValue
				that.finished = false
				that.list = []
				that.onLoad()
			},
			Detail(row) {
				console.log(row)
				let that = this
				if(row.Bq001_042==0){
					//未成功入组
				}else
				{					
					that.$router.push({
						name: "s400PatientFollowDetail",
						params: row
					})
				}
			}
		},
		mounted() {
			// 设置默认MenuId
			this.$http.defaults.headers.common["MenuId"] = "dbff3de6-2d07-4627-b33c-7c0ca9bc57b9";
		}
	}
</script>
<style scoped>
	.filter-box {
		font-size: 14px;
		color: #409EFF;
		letter-spacing: 0;
		text-align: left;
		line-height: 14px;
	}

	.patient-title {
		padding-right: 10px;
		margin-left: 2rem;
	}

	.patient-detail {
		padding-top: 3px;
		margin-left: 1.5rem;
	}

	.patient-detail .patient-detail-item {
		display: inline-block;
		font-size: 14px;
		color: #999999;
		line-height: 14px;
		font-weight: 400;
		padding-left: 20px;
	}

	.patient-detail .patient-status {
		display: inline-block;
		height: 20px;
		width: 60px;
		line-height: 20px;
		text-align: center;
		font-size: 10px !important;
		color: #FF7B61;
		background: rgba(255, 123, 97, 0.06);
		border: 1px solid #FF7B61;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.patient-detail .patient-status.active {
		background: rgba(64, 158, 255, 0.06);
		border: 1px solid #409EFF;
		color: #409EFF;
	}

	/deep/.van-search .van-cell {
		padding-top: 5px;
		padding-bottom: 5px;
	}

	/deep/.van-cell {
		padding-top: 15px;
		padding-bottom: 19px;
	}
</style>
